import Criteria from "@ovh-ui/oui-criteria";

// Deprecated: Support only for old use
// Has been moved to 'oui.criteria'
export default angular
    .module("oui.criteria-container", [Criteria])
    .name;
